export const QNA_STATUS = {
  OPEN: 'open',
  ANSWERED: 'answered',
  CLOSED: 'closed',
};

export const QNA_ANSWER_TYPE = {
  OFFICIAL: 'official',
  FOLLOWUP: 'followup',
  LEGACY: 'legacy',
};

export const QNA_STATUS_LABELS = {
  [QNA_STATUS.OPEN]: 'Odprto',
  [QNA_STATUS.ANSWERED]: 'Odgovorjeno',
  [QNA_STATUS.CLOSED]: 'Zaključeno',
};

export const QNA_ANSWER_TYPE_LABELS = {
  [QNA_ANSWER_TYPE.OFFICIAL]: 'Odgovor sindikata',
  [QNA_ANSWER_TYPE.FOLLOWUP]: 'Dodatno vprašanje',
  [QNA_ANSWER_TYPE.LEGACY]: 'Odgovor',
};

export const QNA_CLOSE_REMINDER_MESSAGE =
  'Prejeli ste odgovor. Če ste zadovoljni, zaključite vprašanje, sicer lahko postavite dodatno vprašanje.';
